<ng-container *ngFor="let item of navigations">
  <div class="title navigate" [routerLink]="item.nav">{{ item.label }}</div>
  <div class="title">&nbsp;|&nbsp;</div>
</ng-container>
<div class="title">{{ title }}</div>
<div class="buttons">
  <ng-content select="mims-ribbon-button"></ng-content>
  <ng-content select="mims-ribbon-alt-action"></ng-content>
</div>
